import { PackageItem } from './package-item.model';
import { Product } from './product';

export class PackageService {
    id: number = 0;
    marinaId: number = 0;
    product: Product = new Product();
    name: string = '';
    description: string = '';
    daysDuration: number = 0;
    active: boolean = true;
    packageItems: PackageItem[] = [];

    constructor() {}
}
